import React from 'react';
import './TopBody.css';

export default class TopBody extends React.Component{
	
	static defaultProps = {
		header: 'header',
		title: 'title',
		className: ''
	};
	
	render = () => {
		return (
			<div className={`${this.props.className} rcg-top-body-container`}>
				
				<div>
					<h3 className="rcg-small-title text-outline">{this.props.header}</h3>
					<h1 className="rcg-big-title">{this.props.title}</h1>
				</div>
				
				<div className="rcg-subtitle">
					<p className="user-content">Genesis strives to serve the highest quality foods and drinks using only organic and healthy ingredients.</p>
				</div>
				
			</div>
		);
	};
}


// WEBPACK FOOTER //
// ./src/components/TopBody.js